import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/sysSupplier'
const BASE_REQUEST_CONTACT = '/tms/sysSupplierContacts'
const BASE_REQUEST_LINK = '/tms/sysSupplierContactLink'

let PromiseCache_getAllSysSupplier = null
export function getAllSysSupplier(querydata) {
  if (PromiseCache_getAllSysSupplier) {
    return PromiseCache_getAllSysSupplier
  }
  const tmp = request({
    url:`${BASE_REQUEST}/getAllSysSupplier`,
    data:querydata
  })
  tmp.then(()=>{
    PromiseCache_getAllSysSupplier = tmp
  })
  return tmp
}


export function unusedAcceptances(isShanDong) {
  return request({
    url:`${BASE_REQUEST}/unusedAcceptances`,
    data:{isShanDong}
  })
}

export function getSysSupplierContactList(querydata) {
    return request({
        url:`${BASE_REQUEST}/getSysSupplierContactList`,
        data:querydata
    })
}

export function saveAndUpdateSysSupplierContacts(querydata) {
  return request({
    url:`${BASE_REQUEST}/saveAndUpdateSysSupplierContacts`,
    data:querydata
  })
}


export function saveAndUpdateSysSupplierContactsLink(querydata) {
  return request({
    url:`${BASE_REQUEST}/saveAndUpdateSysSupplierContactsLink`,
    data:querydata
  })
}

export function deleteSysSupplierContacts(id) {
  return request({
    url:`${BASE_REQUEST}/deleteSysSupplierContacts`,
    data: {
      id:id
    }
  })
}

export function deleteSysSupplierContactsLink(id) {
  return request({
    url:`${BASE_REQUEST}/deleteSysSupplierContactsLink`,
    data: {
      id:id
    }
  })
}

export function getSysSupplierList(querydata) {
        return request({
            url:`${BASE_REQUEST}/getSysSupplierList`,
            data:querydata
        })
}

export function updateSysSupplier(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/updateSysSupplier`,
        data:obj
    })
}

export function delSysSupplier(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delSysSupplier`,
        data:{id: id}
    })
}

export function saveSysSupplier(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/saveSysSupplier`,
        data:obj
    })
}

export function saveSysSupplierSimpleFull(
  obj
) {
  return request({
    url:`${BASE_REQUEST}/saveSysSupplierSimpleFull`,
    data:obj
  })
}

export function getGoodsSupplier(querydata) {
  return request({
    url:`${BASE_REQUEST}/getGoodsSupplier`,
    data:querydata
  })
}

export function getShipSupplier(querydata) {
  return request({
    url:`${BASE_REQUEST}/getShipSupplier`,
    data:querydata
  })
}

export function getShipIncome(querydata) {
  return request({
    url:`${BASE_REQUEST}/getShipIncome`,
    data:querydata
  })
}

export function getTicketSupplier(querydata) {
  return request({
    url:`${BASE_REQUEST}/getTicketSupplier`,
    data:querydata
  })
}

export function getSettleCompanyList(id) {
  return request({
    url:`${BASE_REQUEST}/getSettleCompanyList`,
    data:{shipOwnerId:id}
  })
}

export function getSettleOutMeList(id) {
  return request({
    url:`${BASE_REQUEST}/getSettleOutMeList`,
    data:{sysSupplierId:id}
  })
}
export function delRemoveSettleBySimpleIdAndFullId(simpleId,fullId) {
  return request({
    url:`${BASE_REQUEST}/delRemoveSettleBySimpleIdAndFullId`,
    data:{simpleId:simpleId,fullId:fullId}
  })
}

export function saveSysSupplierContactsLink(obj) {
  return request({
    url:`${BASE_REQUEST_LINK}/saveSysSupplierContactsLink`,
    data: obj
  })
}

export function saveSysSupplierContacts(obj) {
  return request({
    url:`${BASE_REQUEST_CONTACT}/saveSysSupplierContacts`,
    data: obj
  })
}



